<ul class="category-list row">
  <li *ngFor="let category of categories" class="category-list-item col-6 col-lg-4">
    <ish-category-tile [categoryUniqueId]="category"></ish-category-tile>
  </li>
</ul>
